"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalFunctionUtil = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
class PersonalFunctionUtil {
    static relationSetDestToRelationSetDestAttribute(relationSetDest) {
        const attri = relationSetDest.attributesV2;
        if (attri) {
            attri.destId = relationSetDest.id;
            // FIXME: 需要解决该地方
            attri.originElement = (0, cloneDeep_1.default)(relationSetDest);
        }
        return attri;
    }
}
exports.PersonalFunctionUtil = PersonalFunctionUtil;
